import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Input,
  Row,
  Table,
  Col,
  Progress,
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import NotificationAlert from 'react-notification-alert';

import { db } from '../MY_LOGIN_AND_SIGNUP/db/config';
import firebase from 'firebase';

function AddMaterialStudent({ handleClose, notifi, currentStuId }) {
  const notification = useRef();

  const { handleSubmit, register, errors, reset } = useForm();
  const [bookData, setBookData] = useState([]);
  const [quizData, setQuizData] = useState([]);
  const [selectedBook, setSelectedBook] = useState({});
  const [selectedQuiz, setSelectedQuiz] = useState({});
  const [selectedQuizCount, setSelectedQuizCount] = useState([]);
  const [selectedBookCount, setSelectedBookCount] = useState([]);
  const [progressVisible, setProgressVisible] = useState(true);
  const [progressValue, setProgressValue] = useState(8);
  const [currentUser, setCurrentUser] = useState();
  const [teacherList, setTeacherList] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState([]);

  const [addedBooks, setAddedBooks] = useState({});
  const [addedQuizes, setAddedQuizes] = useState({});
  const [selectedQuizTest, setSelectedQuizTest] = useState([]);
  const [selectedQuizAssignTest, setSelectedQuizAssignTest] = useState([]);

  const notify = (msg, err) => {
    let color = err === true ? 'danger' : 'success';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === true ? 'Error' : 'Success'}</b> -{msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notification.current.notificationAlert(options);
    }
  };
  let bookCount = Object.entries(selectedBook).map(([k, v], i) => {
    return { id: k, value: v };
  });
  let quizCount = Object.entries(selectedQuiz).map(([k, v], i) => {
    return { id: k, value: v };
  });

  let bookAddedCount = Object.entries(addedBooks)?.map(([k, v], i) => {
    return { id: k, value: v };
  });

  let quizAddedCount = Object.entries(addedQuizes)?.map(([k, v], i) => {
    return { id: k, value: v };
  });

  useEffect(() => {
    bookCount = bookCount.filter((item) => item.value === true);
    setSelectedBookCount(bookCount);
  }, [selectedBook]);

  useEffect(() => {
    quizCount = quizCount.filter((item) => item.value === true);
    setSelectedQuizCount(quizCount);
  }, [selectedQuiz]);

  // const getBookData = (needfilter) => {
  //   db.collection('zSystemStore')
  //     .where('type', '==', 'book')
  //     .get()
  //     .then((querySnapshot) => {
  //       let book = querySnapshot.docs.map((doc) => doc.data());
  //       setBookData(book);
  //     });
  // };


  const getBooks = (material) => {
    console.log(selectedTeacher, "selectedTeacherselectedTeacher");
    if(selectedTeacher.id){
      db.collection('zSystemStore')
        .where('type', '==', 'book')
        .where('createdBy', '==', selectedTeacher.id)
        .get()
        .then((querySnapshot) => {
          let data = querySnapshot.docs.map((doc) => doc.data());
          let bookArray = {};
          if (material?.book){
          material.book.forEach((item, i) => {
            bookArray[item] = true;
          });
        }
          setAddedBooks(bookArray);
          setSelectedBook(bookArray);
          setBookData(data);
          console.log(data,"check 1");
        })
        .catch((err) => {
          notify(err.toString(), true);
          console.log('err', err);
        });
    }else{
      db.collection('zSystemStore')
        .where('type', '==', 'book')
        .get()
        .then((querySnapshot) => {
          let data = querySnapshot.docs.map((doc) => doc.data());
          let bookArray = {};
          if (material?.book){
          material.book.forEach((item, i) => {
            bookArray[item] = true;
          });
          }
          setAddedBooks(bookArray);
          setSelectedBook(bookArray);
          setBookData(data);
          console.log(data, "check 2");

        })
        .catch((err) => {
          notify(err.toString(), true);
          console.log('err', err);
        });
    }
  };

  const getQuiz = (material) => {
    db.collection('zSystemStore')
      .where('type', '==', 'quiz')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        let quizArray = {};

        material.quiz.forEach((item, i) => {
          quizArray[item] = true;
        });
        setAddedQuizes(quizArray);
        setProgressVisible(false);
        setSelectedQuiz(quizArray);
        setQuizData(data);
      })
      .catch((err) => {
        notify(err.toString(), true);
        console.log('err', err);
      });
  };

 const getQuizTest = () => {
    try {
      const studentRef = db.collection('zSystemStudents').doc(currentStuId);
      studentRef.get()
        .then((studentDoc) => {
          if (studentDoc.exists) {
            const quizTestData = studentDoc.data().quizTest || [];
            const quizTestAssignedByData = studentDoc.data().quizTestAssignedBy || [];
            console.log("Fetched quizTest data:", quizTestData);
            setSelectedQuizTest(quizTestData);
            setSelectedQuizAssignTest(quizTestAssignedByData)
            console.log("Updated selectedQuizTest state:", quizTestData);
          } else {
            console.log("No such student document!");
          }
        })
        .catch((error) => {
          // Handle any errors that occur while fetching data
          console.error("Error fetching student data:", error);
        });

        db.collection('QuizTest')
            .where('status', '==', 0)
            .orderBy('createdAt', 'desc')
            .get()
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                    select: false, // Add select flag for UI interactions
                }));
                console.log("Fetched Mock Data:", data);
                setQuizData(data);
            })
            .catch((err) => {
                console.error("Error fetching quizzes:", err);
            });
    } catch (error) {
        console.error("Error in getQuizTest:", error);
    }
};

  const handleCheckboxChange = (quizTestId, isChecked) => {
    try {
      setSelectedQuizTest((prevSelected) =>
        isChecked
          ? [...prevSelected, quizTestId] // Add if checked
          : prevSelected.filter((id) => id !== quizTestId) // Remove if unchecked
      );

      setSelectedQuizAssignTest((prevSelected) =>
        isChecked
          ? [...prevSelected, { quizTestId, assignedBy: currentUser.createdBy, isTeacher: currentUser.isTeacher }] // Add if checked
          : prevSelected.filter((quiz) => quiz.quizTestId !== quizTestId) // Remove if unchecked
      );

    } catch (error) {
      console.error(error);
    }
  };



  const SubmitHandler = async () => {
    try {
      console.log(selectedQuizTest, currentStuId, "selectedQuizTest");
      const studentRef = db.collection('zSystemStudents').doc(currentStuId);

      const studentDoc = await studentRef.get();
      if (!studentDoc.exists) {
        console.log("No such student!");
        return;
      }

      await studentRef.update({
        quizTest: selectedQuizTest,
        quizTestAssignedBy: selectedQuizAssignTest
      });

      console.log("Mock Test data saved successfully!");

    } catch (error) {
      console.error("Error saving quiz data:", error);
    }
  };

    const getCurrentUser = () => {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          db.collection('zSystemUsers')
            .doc(user.uid)
            .get()
            .then((query) => {
              let data = query.data();
              if (data.isTeacher) {
                setSelectedTeacher({ id: data._uniqueID, batchIds: data.isBatchManage, name: data.firstname + " " + data.lastname })
              }
              setCurrentUser({ isTeacher: data.isTeacher || false, createdBy: data._uniqueID, creatorName: data.firstname + " " + data.lastname });
            });
        }
      });
    };

  const getTeacher = async () => {
    try {
      const userSnapshot = await db.collection('zSystemUsers')
        .where('isTeacher', '==', true)
        .where('status', '==', 0)
        .get();

      let teacher = userSnapshot.docs.map(doc => ({ id: doc.id, batchIds: doc.data().isBatchManage, name: doc.data().firstname + " " + doc.data().lastname }));
     console.log(teacher,'checking Teacher');
      // setSelectedTeacher(teacher[0] || [])
      setTeacherList(teacher);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getCurrentUser()
    getTeacher()
    setProgressValue(99);
    db.collection('studyMaterial')
      .doc(currentStuId)
      .get()
      .then((doc) => {
        getQuizTest()
        if (doc.exists) {
          getBooks(doc.data());

          // getQuiz(doc.data());
          return;
        }
        getBooks();

        // getBookData();
        // getQuizData();
      });
  }, []);

  useEffect(()=>{
      db.collection('studyMaterial')
        .doc(currentStuId)
        .get()
        .then((doc) => {
          getQuizTest()
          if (doc.exists) {
            getBooks(doc.data());
  
            // getQuiz(doc.data());
            return;
          }
          // getBookData();
          // getQuizData();
        });
    
  },[selectedTeacher])

  const onSubmit = (data) => {
    let deletedBooks = bookAddedCount
      ?.filter((item) => item.value === false)
      .map((item) => item.id);
    let deletedQuizes = quizAddedCount
      ?.filter((item) => item.value === false)
      .map((item) => item.id);
    console.log('deleted', deletedBooks, deletedQuizes);
    // return
    let finalSelectedQuiz =
      selectedQuizCount.lenght !== 0
        ? selectedQuizCount.map((item) => item.id)
        : [];
    let finalSelectedBook =
      selectedBookCount.lenght !== 0
        ? selectedBookCount.map((item) => item.id)
        : [];
    db.collection('studyMaterial')
      .doc(currentStuId)
      .set(
        {
          book: finalSelectedBook,
          quiz: finalSelectedQuiz,
          deletedBooks: deletedBooks,
          deletedQuizes: deletedQuizes,
          type: 'student',
        },
        { merge: true }
      )
      .then((res) => {
        handleClose();
        notifi('Study material added Successfully', false);
      });

    return;
  };

  console.log('selectedbooks', selectedBook);
  console.log('selectedquiz', selectedQuiz);

  return (
    <div
      style={{
        backgroundColor: '#1f1e2e',
        height: '100%',
        overflowY: 'scroll',
      }}
    >
      {progressVisible && (
        <Progress color='info' value={progressValue} style={{ height: 4 }} />
      )}

      <div className='react-notification-alert-container'>
        <NotificationAlert ref={notification} />
      </div>

      <div style={{ padding: '5px 20px' }}>
        <Row style={{ justifyContent: 'flex-end' }}>
          <IconButton
            edge='start'
            style={{ color: 'white' }}
            onClick={handleClose}
            aria-label='close'
          >
            <CloseIcon />
          </IconButton>
        </Row>
        <Row>
          <Col md='12' style={{ marginBottom: '100px' }}>
            <Card style={{ margin: 0 }}>
              <CardHeader>
                <h5 className='title'>Add Study Material</h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col sm={6} style={{ borderRight: '1px solid #3d4356' }}>
                  <div style={{display:'flex',alignItems:'center'}}>
   <h5 className='title' style={{ paddingLeft: '20px', marginTop: '13px',paddingRight:'10px'}}>
                      Books
                    </h5>
                {/* {currentUser?.isTeacher?"":
                
                    <select
                      id="subject"
                      className="form-control"
                      value={selectedTeacher?.id || ""}
                      onChange={(e) => {
                        if (e.target.value != "") {
                          const currentTeacher = teacherList.find(teacher => teacher.id.toString() === e.target.value);
                          setSelectedTeacher(currentTeacher);
                          console.log(e.target.value, currentTeacher, 'isSelected');
                        } else {
                          console.log('isSetEmpty');
                          setSelectedTeacher([])
                        }
                      }}
                      style={{
                        maxWidth: '200px',
                        border: '1px solid rgb(42.67, 52.71, 82.83)',
                        borderRadius: '4px',
                        padding: '5px 10px',
                      }}
                    >
                      <option value=""> View All Teacher Material</option>
                      {teacherList.map((teacher) => (
                        <option key={teacher.id} value={teacher.id}>
                          {teacher.name}
                        </option>
                      ))}
                    </select>
} */}
                  </div>
                    <br></br>
{bookData.length>0?
                    <Table className='tablesorter'>
                      <thead className='text-primary'>
                        <tr>
                          <th> </th>
                          <th>Book Title</th>
                          <th>Author</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookData.map((item) => {
                          return (
                            <tr key={item.itemID}>
                              <td
                                style={{ display: 'flex', paddingLeft: '20px' }}
                              >
                                <Input
                                  type='checkbox'
                                  checked={selectedBook[item.itemID]}
                                  onChange={(e) => {
                                    if (addedBooks[item.itemID] !== undefined) {
                                      setAddedBooks((prev) => ({
                                        ...prev,
                                        [item.itemID]: !prev[item.itemID],
                                      }));
                                    }
                                    setSelectedBook((prev) => ({
                                      ...prev,
                                      [item.itemID]: !prev[item.itemID],
                                    }));
                                  }}
                                />
                              </td>
                              <td>{item.title}</td>
                              <td>{item.author}</td>
                              <td style={{ minWidth: '70px' }}>
                                ₹ {item.price}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      </Table> : <div
                        style={{
                          textAlign: 'center',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          padding: '20px',
                          border: '1px solid #ddd',
                          borderRadius: '8px',
                          marginTop: '20px',
                          color: 'white'
                        }}
                      >
                        Books are Not Available
                      </div>
                    }
                  </Col>

                  <Col sm={6} style={{ borderRight: '1px solid #3d4356' }}>
                    <h5 className='title' style={{ paddingLeft: '20px' }}>
                      Mock
                    </h5>
                    <br></br>
                    <Table className='tablesorter'>
                      <thead className='text-primary'>
                        <tr>
                          <th> </th>
                          <th>Mock Title</th>
                          <th>No of Questions</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {quizData.map((item) => {
                          return (
                            <tr key={item.itemID}>
                              <td
                                style={{ display: 'flex', paddingLeft: '20px' }}
                              >
                                <Input
                                  type='checkbox'
                                  disabled={selectedQuizAssignTest.some(
                                    (quiz) => quiz.quizTestId === item.id && quiz.assignedBy !== currentUser.createdBy && currentUser.isTeacher
                                  )}
                                  checked={selectedQuizTest.includes(item.id)}
                                  onChange={(e) => { handleCheckboxChange(item.id,e.currentTarget.checked) }}
                                />
                              </td>
                              <td>{item.name}</td>
                              <td>{item.numberOfQuation}</td>
                              <td style={{ minWidth: '70px' }}>
                                ₹ {item.price || 0}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Col>

                </Row>
                <br></br>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* {selectedBookCount.length !== 0 ||
        selectedQuizCount.length !== 0 ? ( */}
        <Row
          style={{
            position: 'fixed',
            bottom: '0',
            minHeight: '60px',
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            left: '-10',
            backgroundColor: '#272a3d',
          }}
        >
          <Form
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row style={{ width: '100%', alignItems: 'center' }}>
              <Button color='info' type='submit' onClick={SubmitHandler}>
                Submit
              </Button>
            </Row>
          </Form>
        </Row>
        {/* ) : (
          <div></div>
        )} */}
      </div>
    </div>
  );
}
export default AddMaterialStudent;
